import { postApi } from "./api_instance";

export const contactUs = async (formData, dispatch) => {
  try {
    // console.log("Form :", formData);
    return await postApi({
      apiUrl: "/api/contact-us",
      dispatch,
      data: formData,
    });
  } catch (error) {
    throw error;
  }
};
